import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import {
  cancelMessageBotAssistantAction,
  deleteBotAssistantConversationAction,
  formatMessage,
  sendMessageBotAssistantAction,
} from "../actions";
import {
  getIsLoading,
  getConversationMessages,
} from "../selectors";
import { SEND_MESSAGE_FULFILLED } from "../actionTypes";
import { openDialogAction } from "@icarius-common/dialog/actions";

const useBotAssistant = () => {

  const [conversationId, setConversationId] = useState(null);

  const dispatch = useDispatch();
  const isLoading = useSelector(getIsLoading);
  const conversationMessages = useSelector(getConversationMessages);

  const handleOpenBotAssistant = (newId) => {
    if (!conversationMessages[newId]) { // si no hay conversacion, agregar mensaje inicial del bot
      dispatch({
        type: SEND_MESSAGE_FULFILLED,
        payload: {
          conversationId: newId,
          message: formatMessage({ text: getLocalizedString("botInitialMessage") }),
        }
      });
    }

    setConversationId(newId);
  }

  const handleCloseBotAssistant = () => setConversationId(null);

  const handleSubmitMessage = (text, attachments) => {
    dispatch(sendMessageBotAssistantAction(conversationId, text, attachments));
  }

  const handleCancelSubmitMessage = () => {
    dispatch(cancelMessageBotAssistantAction(conversationId));
  }

  const handleResetConversation = () => {
    dispatch(openDialogAction({
      title: getLocalizedString("atention"),
      msg: getLocalizedString("confirmDeleteConversation"),
      onConfirm: () => dispatch(deleteBotAssistantConversationAction(conversationId)),
    }));
  }

  const selectedConversationMessages = conversationMessages?.[conversationId] ?? [];
  const conversationIsAssistantLoading = isLoading[conversationId] || false;

  return {
    conversationId,
    conversationIsAssistantLoading,
    selectedConversationMessages,
    handleOpenBotAssistant,
    handleCloseBotAssistant,
    handleSubmitMessage,
    handleCancelSubmitMessage,
    handleResetConversation,
  }
}

export default useBotAssistant;